/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserDeveloperInput = {|
  clientMutationId?: ?string,
  userRowId: any,
  isDeveloper: boolean,
|};
export type setUserDeveloperMutationVariables = {|
  input: SetUserDeveloperInput
|};
export type setUserDeveloperMutationResponse = {|
  +setUserDeveloper: ?{|
    +userRowId: ?any,
    +isDeveloper: ?boolean,
  |}
|};
export type setUserDeveloperMutation = {|
  variables: setUserDeveloperMutationVariables,
  response: setUserDeveloperMutationResponse,
|};
*/


/*
mutation setUserDeveloperMutation(
  $input: SetUserDeveloperInput!
) {
  setUserDeveloper(input: $input) {
    userRowId
    isDeveloper
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserDeveloperInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserDeveloperPayload",
    "kind": "LinkedField",
    "name": "setUserDeveloper",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userRowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeveloper",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setUserDeveloperMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setUserDeveloperMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "setUserDeveloperMutation",
    "operationKind": "mutation",
    "text": "mutation setUserDeveloperMutation(\n  $input: SetUserDeveloperInput!\n) {\n  setUserDeveloper(input: $input) {\n    userRowId\n    isDeveloper\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e48abb9dfc18932c27bddc72f8f1470e';

module.exports = node;
